import {
  ADD_TO_CART_REQUEST,
  ADD_TO_CART_SUCCESS,
  ADD_TO_CART_FAIL,
  REMOVE_FROM_CART_REQUEST,
  REMOVE_FROM_CART_SUCCESS,
  REMOVE_FROM_CART_FAIL,
  TOTAL_PRICE,
} from './actionTypes'

export const addToCart = item => (dispatch, getState) => {
  try {
    dispatch({ type: ADD_TO_CART_REQUEST })
    dispatch({ type: ADD_TO_CART_SUCCESS, payload: item })
    dispatch({ type: TOTAL_PRICE })

    localStorage.setItem(
      'cartItems',
      JSON.stringify(getState().cart.cartItems)
    )

  } catch (err) {
    console.log(err)
    dispatch({ type: ADD_TO_CART_FAIL, payload: 'Can not add to cart' })
  }
}

export const removeFromCart = _id => (dispatch, getState) => {
  try {
    dispatch({ type: REMOVE_FROM_CART_REQUEST })
    dispatch({ type: REMOVE_FROM_CART_SUCCESS, payload: _id })
    dispatch({ type: TOTAL_PRICE })

    localStorage.setItem(
      'cartItems',
      JSON.stringify(getState().cart.cartItems)
    )

  } catch (err) {
    console.log(err)
    dispatch({ type: REMOVE_FROM_CART_FAIL, payload: 'Can not remove from cart' })
  }
}